import { SendFormsOrigin, SendFormStep } from '../../types';

/**
 * Returns the current viewport dimensions.
 */
export function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export function getSendFormOrigin(origin: SendFormsOrigin) {
  switch (origin) {
    case SendFormsOrigin.FORMS:
      return 'forms';

    case SendFormsOrigin.CONTACTS:
      return 'contacts';

    case SendFormsOrigin.COMPLETE:
      return 'kiosk';

    default:
      return 'none';
  }
}

export function getSendFormStep(step: SendFormStep) {
  switch (step) {
    case SendFormStep.SELECT_CONTACT:
      return 'select-contact';

    case SendFormStep.SELECT_APPOINTMENT:
      return 'select-appointment';

    case SendFormStep.SELECT_DELIVERY_METHOD:
      return 'select-delivery-method';

    case SendFormStep.SELECT_DOCUMENT:
      return 'select-document';

    case SendFormStep.SELECTED_MESSAGE_MODE:
      return 'selected-message-mode';

    case SendFormStep.SELECT_LOCATION:
      return 'select-location';

    default:
      return 'unknown-step';
  }
}
